import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/enviroments';
import { Tgr, ResultTgrDetail, TgrDebtWithAgreement, Quote } from '../interface/tgr';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class TgrServiceService {

  constructor(private http: HttpClient) { }

  /*
    * Metodos para realizar consulta API TGR
  */

  //Crea un registro TGR
  newTgr(request: number): Observable<any> {
    const endpoint = `${environment.apiUrl}/Tgr/${request}/RequestNew`;
    return this.http.get(endpoint);
  }

  //Obtiene un registro TGR
  getTgr(request: Number): Observable<any> {
    const endpoint = `${environment.apiUrl}/Tgr/${request}`;
    return this.http.get<Tgr>(endpoint);
  }

  //Obtiene TGR - Detalle
  getTgrDetail(companyId: Number): Observable<any> {
    const endpoint = `${environment.apiUrl}/Tgr/${companyId}/TgrDetail`;
    return this.http.get<ResultTgrDetail>(endpoint);
  }

  //Obtiene TGR - Quotes
  getTgrQuotes(companyId: Number): Observable<any> {
    const endpoint = `${environment.apiUrl}/Tgr/${companyId}/TgrQuotes`;
    return this.http.get<Quote>(endpoint);
  }

  //Modifica un registro TGR
  // setTgr(request: Tgr): Observable<any> {
  //   const endpoint = `${environment.apiUrl}/?/${request}/?`;
  //   return this.http.put<Tgr[]>(endpoint, request);
  // }

}
